export const faqAleloTudo = [
    {
        question: 'O que é o Alelo Tudo?',
        answer: 'É um único cartão que oferece os produtos Alelo Refeição, Alimentação e Benefícios. Com ele na mão, você tem acesso às redes de benefícios alimentação e refeição, conta com descontos em medicamentos, auxílio mobilidade, auxílio home office e até adiantamento salarial. Ou seja, o Alelo Tudo é um cartão completo e carregado de várias possibilidades. Único, prático e a sua cara.'
    },
    {
        question: 'Como funciona o Alelo Tudo?',
        answer: 'O Alelo Tudo chegou em 2020 oferecendo mais flexibilidade para contratação de diversas redes de benefícios da Alelo. Com ele, a empresa pode contratar os produtos Alelo Alimentação, Refeição e Multibenefícios em contas separadas, a fim de garantir que o saldo seja disponibilizado de forma distinta em cada uma das redes.'
    },
    {
        question: 'Onde o cartão Alelo Tudo é aceito?',
        answer: 'O Alelo Tudo é aceito em mais de 700 mil estabelecimentos em todo o Brasil e, pode ser utilizado para pagamento de auxílio home office, ajuda de custo para abastecimento, para compra de medicamentos com descontos de até 85%, pagamento de compras no supermercado, pedidos em deliveries e muito mais!'
    },
    {
        question:
            'Quais as vantagens de oferecer o Alelo Tudo para meus colaboradores?',
        answer: 'Oferecendo uma ampla variedade de benefícios e auxílios com praticidade e uma variedade de rede de aceitação, a empresa ganha a satisfação do colaborador, melhora sua experiência e ainda simplifica sua jornada de trabalho! Além disso, em meio à pandemia, o colaborador tem acesso a serviços digitais, como o aplicativo Meu Alelo, podendo pagar contas, fazer recarregar o celular, pedir delivery e consultar o saldo pelo WhatsApp da maneira mais segura possível.'
    }
]

export const faqAleloPOD = [
    {
        question:
            'O colaborador pode usar o saldo do Alelo Pod do jeito que preferir?',
        answer: 'Não, depende do que for contratado. Os saldos ficam separados e possuem rede de aceitação específica para garantir a finalidade de uso de cada um. Mas lembre-se que a responsabilidade pelos benefícios concedidos aos funcionários é das empresas contratantes, de modo que devem sempre observar suas convenções e acordos coletivos de trabalho, bem como legislações aplicáveis aos benefícios concedidos.'
    },
    {
        question:
            'Como realizar meu primeiro acesso no Portal de Gestão Alelo Pod?',
        answer: 'Assim que o cadastro da empresa for aprovado, você receberá um e-mail para realizar seu primeiro acesso ao Portal de Gestão Alelo Pod, devendo cadastrar uma senha, que será usada para efetuar o login.'
    },
    {
        question:
            'Ao realizar um pedido, os créditos são disponibilizados automaticamente nos cartões?',
        answer: 'Não. O valor da carga será disponibilizado nos cartões em até 2 (dois) dias úteis após a confirmação do pagamento do boleto.'
    },
    {
        question: 'Qual a validade do boleto gerado?',
        answer: 'Os boletos gerados possuem validade de 30 dias corridos.'
    },
    {
        question: 'Existe um valor mínimo para carga nos cartões?',
        answer: 'O valor mínimo é de R$ 0,01.'
    }
]
